import { memo } from "react";
import { LoginTabs } from "./LoginTabs";
import { LoginFormHeader } from "./LoginFormHeader";
import { LoginForm } from "./LoginForm";
import type { UseFormHandleSubmit, UseFormRegister, FieldErrors } from "react-hook-form";

type LoginFormData = {
  user_email: string;
  user_password: string;
};

interface LoginPageContentProps {
  currentLocale: string;
  register: UseFormRegister<LoginFormData>;
  handleSubmit: UseFormHandleSubmit<LoginFormData>;
  errors: FieldErrors<LoginFormData>;
  isSubmitting: boolean;
  loading: boolean;
  loginError: string | null;
  unverifiedEmail?: string | null;
  resendingVerification?: boolean;
  onResendVerification?: () => Promise<void>;
  onSubmit: (data: LoginFormData) => Promise<void>;
  onFocus: () => void;
  onGoToRegister: () => void;
}

export const LoginPageContent = memo(function LoginPageContent({
  currentLocale,
  register,
  handleSubmit,
  errors,
  isSubmitting,
  loading,
  loginError,
  unverifiedEmail,
  resendingVerification,
  onResendVerification,
  onSubmit,
  onFocus,
  onGoToRegister,
}: LoginPageContentProps) {
  return (
    <div className="flex items-start justify-center min-h-[calc(100vh-4rem)] pt-20 pb-8 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-pink-50/50 to-background dark:from-pink-950/20 dark:to-background">
      <div className="w-full max-w-md space-y-6">
        <LoginTabs onGoToRegister={onGoToRegister} />

        {/* Login Form Card */}
        <div className="bg-card border rounded-lg p-8 shadow-lg">
          <div className="space-y-6">
            <LoginFormHeader />

            <LoginForm
              currentLocale={currentLocale}
              register={register}
              handleSubmit={handleSubmit}
              errors={errors}
              isSubmitting={isSubmitting}
              loading={loading}
              loginError={loginError}
              unverifiedEmail={unverifiedEmail}
              resendingVerification={resendingVerification}
              onResendVerification={onResendVerification}
              onSubmit={onSubmit}
              onFocus={onFocus}
            />
          </div>
        </div>
      </div>
    </div>
  );
});

